import { SCondition, RequestQueryBuilder } from '@nestjsx/crud-request';
import { SortDirection } from '@angular/material/sort';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TorchAPIConfiguration } from '../../../../config/api.configuration';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Burly } from 'kb-burly';
import { ManyResponse } from '../../../../responses/many.response';
import { map } from 'rxjs/operators';
import { FleetPainByAcn } from '../../models/fleet-pain-table-acn.model';

@Injectable({
  providedIn: 'root'
})
export class TorchFleetPainAcnService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }


  public queryFleetPainTable(painType: string = '1yr',
                             pageSize: number = 15,
                             currentPage: number = 0,
                             sortDirection: 'ASC' | 'DESC' | '' = 'ASC',
                             sortBy: string = 'rank',
                             filters: SCondition | null): Observable<ManyResponse<FleetPainByAcn>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection && sortDirection != null) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }

    if (!!filters) {
      qb.search(filters);
    }

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/pain-index/fleet/acn/')
      .addSegment(painType)
      .appendRawQueryString(qb.query(false));

    finalURL = endpoint.get;

    return this.httpClient.get<ManyResponse<FleetPainByAcn>>(finalURL);
  }

  public getPainIndexMonths(painType: string = '1yr'): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/pain-index/fleet/acn/')
      .addSegment(painType)
      .addSegment('/painIndexMonth')
      .get;

    return this.httpClient.get<[{ pain_index_month: string }]>(endpoint).pipe(
      map(response => response.map(v => v.pain_index_month))
    );
  }

  public getMaxPainIndexMonth(painType: string = '1yr'): Observable<string> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/pain-index/fleet/acn/')
      .addSegment(painType)
      .addSegment('/maxPainIndexMonth')
      .get;

    return this.httpClient.get<{ pain_index_month: string }>(endpoint).pipe(
      map(response => response.pain_index_month)
    );
  }

  public getDistinctFleets(painType: string = '1yr', contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/pain-index/fleet/acn/')
      .addSegment(painType)
      .addSegment('/fleets')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ fleet_cd: string }]>(endpoint).pipe(
      map(response => response.map(v => v.fleet_cd))
    );
  }

  public getDistinctAcns(painType: string = '1yr', contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/pain-index/fleet/acn/')
      .addSegment(painType)
      .addSegment('/acn')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ acn: string }]>(endpoint).pipe(
      map(response => response.map(v => v.acn))
    );
  }

  public exportToExcel(painType: string = '1yr', painData: FleetPainByAcn[], forBrief?: boolean) {
    return new Observable(subscriber => {
      let endpoint = Burly(this.config.rootUrl)
        .addSegment('/pain-index/fleet/acn/')
        .addSegment(painType)
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType; } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {
        painData: painData
      };

      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });
  }
}
